<ng-template #popTemplate>
    <emoji-mart
        id="emoji-popover"
        [showPreview]="false"
        [emojiSize]="20"
        [autoFocus]="false"
        [darkMode]="false"
        (emojiSelect)="emojiSelect.emit($event); newReplyPopover.hide()"
        [i18n]="emojiConfigService.i18n">
    </emoji-mart>
</ng-template>

<span class="ql-internal-btn" tooltip="{{ 'Emoji' | translate }}" delay="500" container="body">
    <button
        class="btn btn-icon"
        type="button"
        [id]="buttonId"
        [attr.aria-label]="'Emoji picker' | translate"
        [placement]="placement"
        [popover]="popTemplate"
        (onShown)="searchFocus()"
        [outsideClick]="true"
        [containerClass]="containerClass"
        #newReplyPopover="bs-popover"
        container="body"
        (click)="updateQuillSelection.emit()">
        <sb-inline-svg class="icon p-0" [url]="'./sb-tools/theme/images/icons/Thin Icon - Smiley.svg'"> </sb-inline-svg>
    </button>
</span>
